import { View } from "binder"
import { ReplacementReasonEditorViewModel } from "./replacementReasonEditor-viewModel"
import { ToolTypeSelectorViewModel } from "../../toolModelManipulation/toolTypeSelector-viewModel";

export class ReplacementReasonEditorView extends View<ReplacementReasonEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-67492561-378F-4923-921E-2BF4B9ECA057"
    }
    loadHtml(): string {
        let element = require('./replacementReasonEditor.html').default;
        let style = require('./replacementReasonEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set reasonText(v: string) { this._reasonText = v; } public get reasonText(): string { return this._reasonText; } private _reasonText: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId; } private _toolTypeId: string;
    public set toolTypeSelector(v: ToolTypeSelectorViewModel) { this._toolTypeSelector = v; } public get toolTypeSelector(): ToolTypeSelectorViewModel { return this._toolTypeSelector; } private _toolTypeSelector: ToolTypeSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
